module.exports = __webpack_public_path__ + "85a5a115cca1a83ddfedf9aef544785a.pdf";